import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import ContentLoader from "../../components/Loader/ContentLoader";
import blog_img_1 from "../../assets/new_image_ui/blog_img_1.jpg";
// import Button from "../../components/Button/Button";
//action
import { getBlogs } from "../../actions/blogs";

class AdvisorBlog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bolgsData: [],
      allBolgdata: [],
      isActive: "Advisor",
      fetching: false,
    };
  }

  getAllBlogs = async () => {
    const { isActive } = this.state;
    try {
      const res = await getBlogs();
      let resposeData = res && res.length > 0 ? res : [];

      this.setState(
        {
          bolgsData: resposeData,
          allBolgdata: resposeData,
          fetching: true,
        },
        () => this.handleActiveCategories(isActive)
      );
    } catch (err) {
      console.error("getAllBlogs, Server err: ", err.response);
      const data = err.response.data;
      this.setState({ server_error: data.error });
    }
  };

  componentDidMount = () => {
     this.getAllBlogs()
  };

  handleActiveCategories = (clicked) => {
    const { allBolgdata } = this.state;
    // console.log(allBolgdata);
    let filetrList = [];
    if (clicked === "Advisor") {
      // const filterData =
       allBolgdata.filter((item, index) => {
        let data = item.terms.filter((element) => element.name === clicked);
        if (data.length > 0) {
          filetrList.push(allBolgdata[index]);
        }
      });
    }
    // else {
    //   filetrList = allBolgdata;
    // }
    this.setState({
      bolgsData: filetrList,
      isActive: clicked,
      fetching: true,
    });
  };

  render() {
    const { bolgsData, fetching } = this.state;
    return (
      <Fragment>
        {!fetching && (
          <div className="text-center">
            <ContentLoader />
          </div>
        )}
        {fetching && (
          <section className="section" id="blog">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <p className="blog_h pt-5 pb-3 text-center">Blog</p>
                  <div className="row mt-5 mt-4">
                    {bolgsData &&
                      bolgsData.length > 0 &&
                      bolgsData.map((data, index) => {
                        return (
                          <div className="col-sm-4 col-md-4" key={index}>
                    <img src={data.thumbnail && data.thumbnail.link !==""  ? data.thumbnail.link: blog_img_1} alt="img" className="card-radius" width={"100%"}  style={{height:"150px"}} />

                            <Link
                              to={{ pathname: `/advisor_blog_details/${data.id}` }}
                              target="_blank"
                              //isActive={isActive}
                            >
                              <p className="h5 pt-3 text-dark">{data.title}</p>
                            </Link>
                          </div>

                        );
                      })}
                    {bolgsData.length === 0 && (
                      <div className="col-12 text-center mt-5">
                        <p className="par_3">No Data</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </Fragment>
    );
  }
}

export default AdvisorBlog;
